import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 8,
  path: '/supervisionCheck',
  component: Home,
  redirect: '/supervisionCheck/supervision/supervisionTasks',
  name: 'supervisionCheck',
  isHead: true,
  meta: {
    title: '监督检查',
    img: require('@/assets/img/jcgl.png')
  },
  children: [
    {
      path: 'supervision',
      component: () => import('@/views/supervisionCheck/index'),
      name: 'supervisionCheck',
      meta: { title: '监督检查', close: false },
      children: [
        {
          path: 'supervisionTasks',
          name: 'supervisionTasks',
          component: () => import('@/views/supervisionCheck/supervision'),
          meta: { title: '新建检查记录', next: '/supervisionCheck/supervision/norectifyManagement', close: true}
        },
        {
          path: 'norectifyManagement',
          name: 'norectifyManagement',
          component: () => import('@/views/supervisionCheck/norectifyManagement'),
          meta: { title: '未处理隐患管理', next: '/supervisionCheck/supervision/supervision', close: true}
        },
        {
          path: 'supervision',
          component: () => import('@/views/supervisionCheck/temporary'),
          name: 'supervision',
          meta: { title: '临时检查对象', next: '/supervisionCheck/supervision/checkTasks', close: false}
        },
        {
          path: 'checkTasks',
          name: 'checkTasks',
          component: () => import('@/views/supervisionCheck/checkTasks'),
          meta: { title: '检查任务部署', next: '/supervisionCheck/supervision/notcheckTasks', close: true}
        },
        {
          path: 'notcheckTasks',
          name: 'notcheckTasks',
          component: () => import('@/views/supervisionCheck/notcheckTasks'),
          meta: { title: '待检查任务', next: '/supervisionCheck/supervision/deliverTracks', close: true}
        },
        // {
        //   path: 'supervisionTasks',
        //   name: 'supervisionTasks',
        //   component: () => import('@/views/supervisionCheck/supervision'),
        //   meta: { title: '监督检查管理', next: '/supervisionCheck/supervision/supervision', close: true}
        // },
        {
          path: 'deliverTracks',
          name: 'deliverTracks',
          component: () => import('@/views/supervisionCheck/deliverTracks'),
          meta: { title: '隐患移交跟踪', next: '/supervisionCheck/supervision/supervisionTasks', close: true}
        },
        {
          path: 'schedule1',
          name: 'schedule1',
          component: () => import('@/views/hiddenCheck/supervision/components/table'),
          meta: { title: '企业专项检查部署', next: '/supervisionCheck/supervision/schedule2', close: true}
        },
        {
          path: 'schedule2',
          name: 'schedule2',
          component: () => import('@/views/hiddenCheck/supervision/components/table2'),
          meta: { title: '政府检查计划部署', next: '/supervisionCheck/supervision/schedule4', close: true}
        },
        // {
        //   path: 'schedule3',
        //   name: 'schedule3',
        //   component: () => import('@/views/hiddenCheck/supervision/components/supervisionTable'),
        //   meta: { title: '新建检查部署', next: '/supervisionCheck/supervision/schedule3', close: true}
        // },
        {
          path: 'schedule4',
          name: 'schedule4',
          component: () => import('@/views/hiddenCheck/supervision/components/SupervisionExportTable'),
          meta: { title: '检查人员账号管理', close: true}
        },
        {
          path: 'track',
          component: () => import('@/views/analysis/track'),
          name: 'track',
          meta: { title: '检查任务隐患跟踪表', close: true}
        },
        {
          path: 'statistics',
          component: () => import('@/views/analysis/statistics'),
          name: 'statistics',
          meta: { title: '检查层级隐患数统计', close: true}
        },
        {
          path: 'regulate',
          component: () => import('@/views/analysis/regulate'),
          name: 'regulate',
          meta: { title: '检查隐患动态管理', close: true}
        },
        //检查清单维护
        {
          path: 'hideenMaintain',
          name: 'hideenMaintain',
          component: () => import('@/views/hiddenCheck/hideenMaintain/index'),
          meta: {title: '行业领域检查清单', next: '/supervisionCheck/supervision/meshWelding', close: true}
        }, 
        {
          path: 'meshWelding',
          name: 'meshWelding',
          component: () => import('@/views/hiddenCheck/hideenMaintain/meshWelding'),
          meta: {title: '网格员检查导则', next: '/supervisionCheck/supervision/specialList', close: true}
        }, 
        {
          path: 'specialList',
          name: 'specialList',
          component: () => import('@/views/hiddenCheck/hideenMaintain/specialList'),
          meta: {title: '专项检查清单', next: '/supervisionCheck/supervision/dangerList', close: true}
        }, 
        {
          path: 'dangerList',
          name: 'dangerList',
          component: () => import('@/views/hiddenCheck/hideenMaintain/dangerList'),
          meta: {title: '重大隐患检查清单', next: '/supervisionCheck/supervision/mainCheckList', close: true}
        }, 
        {
          path: 'mainCheckList',
          name: 'mainCheckList',
          component: () => import('@/views/hiddenCheck/hideenMaintain/mainCheckList'),
          meta: {title: '主体责任检查清单', close: true}
        }, 
      ]
    }
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/supervisionCheck.js